export const APP_COLORS = {
  uncode:    '#E85D24',  // Orange
  giraffe:   '#10B981',  // Emerald
  framed:    '#D4537E',  // Pink
  cult:      '#F5A623',  // Amber
  soulsync:  '#4B5FD4',  // Indigo
  dash:      '#06B6D4',  // Cyan
  zephyr:    '#6B35B8',  // Purple
  arx:       '#C0A96A',  // Gold
  verve:     '#FF0042',  // Red
  chronicle: '#A0785A',  // Bronze
  library:   '#C0A96A',  // Gold (shared with Arx — both are archives)
  flux:      '#E24B4A',  // Flux red
};

export const DOMAIN_COLORS = {
  soul:   '#AFA9EC',  // Soft purple
  Soul:   '#AFA9EC',
  matrix: '#107270',  // Teal
  Matrix: '#107270',
  both:   '#E8C547',  // Warm yellow
  Both:   '#E8C547',
};

export const SYSTEM_COLORS = {
  background:       '#0a0a0f',
  textPrimary:      '#f0f0f5',
  textSecondary:    '#b0b4c0',
  textTertiary:     '#6b7084',
  textQuaternary:   '#454860',
  queueAmber:       '#E8C547',
};

export const TYPE_COLORS = {
  realization: '#AFA9EC',
  reflection: '#4B5FD4',
  decision: '#10B981',
  pattern: '#E8C547',
  principle: '#E8736F',
};
